import { Injectable } from '@angular/core';
import { CanDeactivate, Router } from '@angular/router';
import { NavLockService } from './nav-lock.service';


export interface ComponentWithNavLock {
  canDeactivate: () => boolean;
}

@Injectable({
  providedIn: 'root'
})
export class NavLockGuard implements CanDeactivate<ComponentWithNavLock> {
  constructor(
    private navLockService: NavLockService,
    private router: Router
  ) {}

  canDeactivate(
    component: ComponentWithNavLock,
    currentRoute: any,
    currentState: any,
    nextState?: any
  ): boolean {
    if (this.navLockService.isLocked()) {
      const nextUrl = nextState?.url || '/';
      console.log('nextUrl', nextUrl);
      this.navLockService.notifyNavigationAttempt(nextUrl);
      return false;
    }
    return true;
  }
}